// extracted by mini-css-extract-plugin
export default {"chatContainer":"Chat_chatContainer__v5enF","chatClientMessage":"Chat_chatClientMessage__+xHim","chatEmployeeMessage":"Chat_chatEmployeeMessage__Z0zuk","date":"Chat_date__IgpFI"};